import { attributeDefinitionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateAttributeDefinition = {
  name: "updateAttributeDefinition" as const,
  input: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
    displayName: z.string().min(1).optional(),
    description: z.string().optional(),
  }),

  output: z.object({ success: z.boolean() }),
};
